<template>
    <svg
        class="fill-current"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.2549 23.4142L19.962 16.7071C20.1495 16.5196 20.2549 16.2652 20.2549 16C20.2549 15.7348 20.1495 15.4805 19.962 15.2929L13.2549 8.58582L11.8407 10L17.8407 16L11.8407 22L13.2549 23.4142Z"
        />
    </svg>
</template>
